import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import ErrorBoundary from './Common/ErrorBoundary/ErrorBoundary';
import TagManager from 'react-gtm-module';
import env from './env';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

ReactDOM.render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>,
  document.getElementById('root')
);

TagManager.initialize({
  gtmId: env.gtm_id,
});
